import { Link } from "react-router-dom";
import { Mail, MapPin, Landmark } from "lucide-react";
import { LOGO_MARK } from "../lib/brand";
import { COMPANY } from "../lib/company";

const LINKS = {
  Company: [
    { to: "/about", label: "About Us" },
    { to: "/how-it-works", label: "How It Works" },
    { to: "/partners", label: "Partners" },
    { to: "/portal", label: "Customer Portal" },
    { to: "/contact", label: "Contact" },
  ],
  Platform: [
    { to: "/platform", label: "Customer Portal" },
    { to: "/platform", label: "Engineering Hub" },
    { to: "/platform", label: "AI Instant Quote" },
    { to: "/platform", label: "Manufacturing Network" },
  ],
  Capabilities: [
    { to: "/manufacturing", label: "Sheet Metal" },
    { to: "/manufacturing", label: "CNC Machining" },
    { to: "/manufacturing", label: "Fabrication" },
    { to: "/manufacturing", label: "3D Printing" },
  ],
};

export const Footer = () => (
  <footer className="bg-slate-950 text-slate-400 border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={LOGO_MARK} alt="Vectron Global" className="h-12 w-auto" />
            <span className="font-heading leading-none">
              <span className="block text-xl font-semibold tracking-wide text-white">VECTRON</span>
              <span className="block text-xs font-medium tracking-[0.35em] text-blue-400">GLOBAL LLP</span>
            </span>
          </div>
          <p className="mt-6 text-sm leading-relaxed max-w-sm">
            On-demand manufacturing and engineering platform connecting your designs to a vetted
            global network of precision manufacturers.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            <p className="flex items-center gap-3"><Mail className="h-4 w-4 text-blue-400" strokeWidth={1.5} /> vectronglobal@gmail.com</p>
            <p className="flex items-start gap-3" data-testid="footer-address"><MapPin className="h-4 w-4 text-blue-400 mt-0.5 shrink-0" strokeWidth={1.5} /><span>{COMPANY.addressLines[0]}<br />{COMPANY.addressLines[1]}</span></p>
            <p className="flex items-center gap-3 font-mono-tech text-xs" data-testid="footer-gstin"><Landmark className="h-4 w-4 text-blue-400" strokeWidth={1.5} /> {COMPANY.legalName} · GSTIN {COMPANY.gstin}</p>
          </div>
        </div>
        {Object.entries(LINKS).map(([group, items]) => (
          <div key={group} className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold uppercase tracking-widest mb-5 font-heading">{group}</h4>
            <ul className="space-y-3">
              {items.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm hover:text-white transition-colors duration-200" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs">
        <p>© {new Date().getFullYear()} VECTRON GLOBAL LLP. All rights reserved.</p>
        <p className="font-mono-tech tracking-wider text-slate-500">ENGINEERED FOR PRECISION</p>
      </div>
    </div>
  </footer>
);
